/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ email: NonNullable<unknown> }} Bot_Optout_EmailInputs */

const en_bot_optout_email = /** @type {(inputs: Bot_Optout_EmailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Want your domain excluded entirely, or to report behaviour that does not match this page? Email ${i?.email}`)
};

const id_bot_optout_email = /** @type {(inputs: Bot_Optout_EmailInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ingin domain Anda dikecualikan sepenuhnya, atau melaporkan perilaku yang tidak sesuai dengan halaman ini? Kirim email ke ${i?.email}`)
};

/**
* | output |
* | --- |
* | "Want your domain excluded entirely, or to report behaviour that does not match this page? Email {email}" |
*
* @param {Bot_Optout_EmailInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const bot_optout_email = /** @type {((inputs: Bot_Optout_EmailInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Bot_Optout_EmailInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_bot_optout_email(inputs)
	return en_bot_optout_email(inputs)
});